var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChalkboardUserDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 44,
    viewBox: "0 0 57 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chalkboard-user-duotone-solid (1) 1",
    clipPath: "url(#clip0_175_4098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 5.5V8.25C16.5387 8.25 18.455 8.78281 20.1 9.71953V5.5H50.9V30.25H45.3H34.1H25.385C27.345 31.668 28.9375 33.5586 29.97 35.75H50.9C53.9888 35.75 56.5 33.2836 56.5 30.25V5.5C56.5 2.46641 53.9888 0 50.9 0H20.1C17.0113 0 14.5 2.46641 14.5 5.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.1 19.25C6.1 17.062 6.985 14.9635 8.5603 13.4164C10.1356 11.8692 12.2722 11 14.5 11C16.7278 11 18.8644 11.8692 20.4397 13.4164C22.015 14.9635 22.9 17.062 22.9 19.25C22.9 21.438 22.015 23.5365 20.4397 25.0836C18.8644 26.6308 16.7278 27.5 14.5 27.5C12.2722 27.5 10.1356 26.6308 8.5603 25.0836C6.985 23.5365 6.1 21.438 6.1 19.25ZM0.5 41.7055C0.5 35.3805 5.72375 30.25 12.1637 30.25H16.8275C23.2762 30.25 28.5 35.3805 28.5 41.7055C28.5 42.9687 27.4587 44 26.1637 44H2.83625C1.54125 44 0.5 42.9773 0.5 41.7055ZM36.9 24.75H42.5C44.0487 24.75 45.3 25.9789 45.3 27.5V30.25H34.1V27.5C34.1 25.9789 35.3512 24.75 36.9 24.75Z",
    fill: "url(#paint0_linear_175_4098)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_4098",
    x1: 0.868439,
    y1: 44,
    x2: 48.588,
    y2: 17.6124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_4098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 44,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChalkboardUserDuotoneSolid);
export default __webpack_public_path__ + "static/media/icon-chalkboard-user-duotone-solid.fc3d914cff58b1324033d189341a51b6.svg";
export { ForwardRef as ReactComponent };